export default __webpack_public_path__ + "static/media/AfterPhoto11.7509f5a7.jpg";